import {ReactNode} from "react";
import {ClassList, DivWrapper} from "./Base";

export const FormRow = (props:{ children?: ReactNode }) => DivWrapper.render(new ClassList('clesy-form-row'), props.children);